import moment from "moment";

export const isOlderThanTwoYears = (date: string | Date) => {
  return moment(date).isBefore(moment().subtract(2, "years"));
};
